<template>
    <v-dialog v-model="infoResidenceTermDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark :color="toolbarColor">
                <v-btn icon dark @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>More Information</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="closeDialog()">Close</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-title>
                {{ currentResidenceTerm.term }}
            </v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentResidenceTerm.datecode" readonly hide-details
                                label="Created Date" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentResidenceTerm.createdByUsername" readonly hide-details
                                label="Created By" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentResidenceTerm.startDate" readonly hide-details
                                label="Term Start Date" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentResidenceTerm.endDate" readonly hide-details
                                label="Term End Date" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="currentResidenceTerm.moveInDate" readonly hide-details
                                label="Move-In Date" placeholder="Not available">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="currentResidenceTerm.active" readonly hide-details :items="activeItems"
                                label="Active" placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select v-model="currentResidenceTerm.default" readonly hide-details
                                :items="defaultItems" label="Default" placeholder="Not available">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="currentResidenceTerm.notes" auto-grow class="pt-5" readonly
                                label="Notes" outlined placeholder="None">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'residence-terms-info',
    props: {
        currentResidenceTerm: {
            required: true,
            type: Object
        },
        infoResidenceTermDialog: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            activeItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
            defaultItems: [{
                    text: 'Yes',
                    value: '1'
                },
                {
                    text: 'No',
                    value: '0'
                }
            ],
        }
    },
    methods: {
        closeDialog() {
            this.$emit('closeInfoResidenceTermDialog');
        },
    },
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>